/*
 * Copyright (c) 2023 SmartWifi - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential. No warranty, explicit or implicit provided. In
 * no event will the author be liable for any claim or damages.
 */

import { Label, Tooltip } from "reactstrap";
import { UniqKey } from "../util/Key";
import Switch from "react-switch";
import useUpdateState from "../util/useUpdateState";

const ThemeSwitch = (props) => {
  // parse out props
  const {
    text,
    tooltip,
    tooltipPlacement,
    checked = false,
    onChange = () => {},
    className,
    offColor = "#888",
    onColor = "#05568E",
    children = null
  } = props;

  // tooltip state
  const [state, , updateState] = useUpdateState({
    id: `theme-switch-${UniqKey()}`,
    open: false
  });

  return (
    <div className={className}>
      <div id={state.id} className="fill-container d-flex align-items-center">
        {text && <Label className="pt-2 pe-2">{text}:</Label>}
        <Switch
          {...props}
          checked={checked}
          onChange={onChange}
          offColor={offColor}
          onColor={onColor}
          className=""
          children={undefined}
        />
        {children}
      </div>
      {tooltip && (
        <Tooltip
          placement={tooltipPlacement}
          isOpen={state.open}
          target={state.id}
          toggle={() => updateState({ open: !state.open })}
        >
          {tooltip}
        </Tooltip>
      )}
    </div>
  );
};

export default ThemeSwitch;
